const $searchForm = $('.js-searchForm')
const $searchSuggest = $('.js-searchSuggest')

$('.js-searchToggle').on('click', () => {
  $searchForm.addClass('is_visible')
  setTimeout(() => {
    $('.js-searchFormInput').focus()
  }, 300)
})

$('.js-searchClose').on('click', () => {
  $('.js-searchFormInput').val('')
  $searchForm.removeClass('is_visible')
  $searchSuggest.removeClass('is_visible')
})

$('.js-searchFormInput').on('input', (e) => {
  const current = $(e.currentTarget)
  const val = current.val()

  if (val !== '' && val.length > 2) {
    $searchSuggest.addClass('is_visible')
  } else {
    $searchSuggest.removeClass('is_visible')
  }
})
